import { render, staticRenderFns } from "./new_file.vue?vue&type=template&id=23707444"
import script from "./new_file.vue?vue&type=script&lang=js"
export * from "./new_file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports